import WidgetLinks from './WidgetLinks';

export default WidgetLinks;
